<h2 mat-dialog-title style="text-align: center!important;">Permissions for {{ userName }}</h2>


<!-- tabs -->




<ul class="nav nav-tabs ml-4">
    <li class="nav-item" *ngIf="accMenus?.length">
        <a class="nav-link" [class.active]="activeTab === 'acc'" (click)="selectTab('acc')">Account</a>
    </li>
    <li class="nav-item" *ngIf="advtMenus?.length">
        <a class="nav-link" [class.active]="activeTab === 'advt'" (click)="selectTab('advt')">Advertisement</a>
    </li>
    <li class="nav-item" *ngIf="subMenus?.length">
        <a class="nav-link" [class.active]="activeTab === 'sub'" (click)="selectTab('sub')">Subscription</a>
    </li>
    <li class="nav-item" *ngIf="issueSellerMenus?.length">
        <a class="nav-link" [class.active]="activeTab === 'is'" (click)="selectTab('is')">Issue Seller</a>
    </li>
    <li class="nav-item" *ngIf="bookMenus?.length">
        <a class="nav-link" [class.active]="activeTab === 'bs'" (click)="selectTab('bs')">Book Store</a>
    </li>
</ul>

<div class="tab-content">


    <div *ngIf="accMenus?.length" class="tab-pane fade" [class.show]="activeTab === 'acc'"
        [class.active]="activeTab === 'acc'">
        <div mat-dialog-content>
            <table class="permissions-table">
                <thead>
                    <tr>
                        <th>Menu</th>
                        <th>View</th>
                        <th>Add</th>
                        <th>Edit</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let menu of accMenus">
                        <td>{{ menu.name }}</td>
                        <td><mat-checkbox [(ngModel)]="menu.view"></mat-checkbox></td>
                        <td><mat-checkbox [(ngModel)]="menu.add"></mat-checkbox></td>
                        <td><mat-checkbox [(ngModel)]="menu.edit"></mat-checkbox></td>
                        <td><mat-checkbox [(ngModel)]="menu.delete"></mat-checkbox></td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div mat-dialog-actions align="end">
            <button mat-button (click)="dialogRef.close()">Cancel</button>
            <button mat-raised-button color="primary" (click)="save()">Save</button>
        </div>
    </div>

    <div class="tab-pane fade" [class.show]="activeTab === 'advt'" [class.active]="activeTab === 'advt'">
        <div mat-dialog-content>
            <table class="permissions-table">
                <thead>
                    <tr>
                        <th>Menu</th>
                        <th>View</th>
                        <th>Add</th>
                        <th>Edit</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let menu of advtMenus">
                        <td>{{ menu.name }}</td>
                        <td><mat-checkbox [(ngModel)]="menu.view"></mat-checkbox></td>
                        <td><mat-checkbox [(ngModel)]="menu.add"></mat-checkbox></td>
                        <td><mat-checkbox [(ngModel)]="menu.edit"></mat-checkbox></td>
                        <td><mat-checkbox [(ngModel)]="menu.delete"></mat-checkbox></td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div mat-dialog-actions align="end">
            <button mat-button (click)="dialogRef.close()">Cancel</button>
            <button mat-raised-button color="primary" (click)="save()">Save</button>
        </div>
    </div>


    <div class="tab-pane fade" [class.show]="activeTab === 'sub'" [class.active]="activeTab === 'sub'">
        <div mat-dialog-content>
            <table class="permissions-table">
                <thead>
                    <tr>
                        <th>Menu</th>
                        <th>View</th>
                        <th>Add</th>
                        <th>Edit</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let menu of subMenus">
                        <td>{{ menu.name }}</td>
                        <td><mat-checkbox [(ngModel)]="menu.view"></mat-checkbox></td>
                        <td><mat-checkbox [(ngModel)]="menu.add"></mat-checkbox></td>
                        <td><mat-checkbox [(ngModel)]="menu.edit"></mat-checkbox></td>
                        <td><mat-checkbox [(ngModel)]="menu.delete"></mat-checkbox></td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div mat-dialog-actions align="end">
            <button mat-button (click)="dialogRef.close()">Cancel</button>
            <button mat-raised-button color="primary" (click)="save()">Save</button>
        </div>
    </div>

    <div class="tab-pane fade" [class.show]="activeTab === 'is'" [class.active]="activeTab === 'is'">
        <div mat-dialog-content>
            <table class="permissions-table">
                <thead>
                    <tr>
                        <th>Menu</th>
                        <th>View</th>
                        <th>Add</th>
                        <th>Edit</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let menu of issueSellerMenus">
                        <td>{{ menu.name }}</td>
                        <td><mat-checkbox [(ngModel)]="menu.view"></mat-checkbox></td>
                        <td><mat-checkbox [(ngModel)]="menu.add"></mat-checkbox></td>
                        <td><mat-checkbox [(ngModel)]="menu.edit"></mat-checkbox></td>
                        <td><mat-checkbox [(ngModel)]="menu.delete"></mat-checkbox></td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div mat-dialog-actions align="end">
            <button mat-button (click)="dialogRef.close()">Cancel</button>
            <button mat-raised-button color="primary" (click)="save()">Save</button>
        </div>
    </div>

    <div class="tab-pane fade" [class.show]="activeTab === 'bs'" [class.active]="activeTab === 'bs'">
        <div mat-dialog-content>
            <table class="permissions-table">
                <thead>
                    <tr>
                        <th>Menu</th>
                        <th>View</th>
                        <th>Add</th>
                        <th>Edit</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let menu of bookMenus">
                        <td>{{ menu.name }}</td>
                        <td><mat-checkbox [(ngModel)]="menu.view"></mat-checkbox></td>
                        <td><mat-checkbox [(ngModel)]="menu.add"></mat-checkbox></td>
                        <td><mat-checkbox [(ngModel)]="menu.edit"></mat-checkbox></td>
                        <td><mat-checkbox [(ngModel)]="menu.delete"></mat-checkbox></td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div mat-dialog-actions align="end">
            <button mat-button (click)="dialogRef.close()">Cancel</button>
            <button mat-raised-button color="primary" (click)="save()">Save</button>
        </div>
    </div>


</div>